export default "__VITE_ASSET__aL_GNn0x__"